<template>

</template>

<script>
export default {
  name: 'CostCenterSubGroup'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CostCenterSubGroup.vue?e54256e6